import { Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type StockItemType = "raw_material" | "product";

interface Props {
  itemType: StockItemType;
  canRemove: boolean;
  onSwitchType: (type: StockItemType) => void;
  onRemove: () => void;
}

const TYPES: { value: StockItemType; label: string }[] = [
  { value: "raw_material", label: "Bahan Baku" },
  { value: "product", label: "Produk Jadi" },
];

/** Header of a restock line: raw material / finished product switcher and remove button. */
export function ExpenseItemModeBar({
  itemType,
  canRemove,
  onSwitchType,
  onRemove,
}: Props) {
  return (
    <div className="flex items-center justify-between gap-2 border-b pb-1.5 text-xs">
      <div className="flex flex-wrap items-center gap-2">
        <div
          role="radiogroup"
          aria-label="Jenis barang restock"
          className="inline-flex rounded-md border bg-background p-0.5 text-[11px]"
        >
          {TYPES.map((type) => {
            const active = itemType === type.value;
            return (
              <button
                key={type.value}
                type="button"
                role="radio"
                aria-checked={active}
                onClick={() => !active && onSwitchType(type.value)}
                className={cn(
                  "rounded-sm px-2.5 py-0.5 font-medium transition-colors",
                  active
                    ? "bg-emerald-600 text-white"
                    : "text-muted-foreground hover:text-foreground",
                )}
              >
                {type.label}
              </button>
            );
          })}
        </div>
        <span className="text-[11px] text-muted-foreground">
          Masuk ke stok saat disimpan
        </span>
      </div>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-6 w-6 text-muted-foreground hover:text-destructive"
        disabled={!canRemove}
        onClick={onRemove}
        title="Hapus baris"
      >
        <Trash2 className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
